/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { xScreen } from "@tps/XDL/Utilities";
import React from "react";
import { css } from "styled-components";

const enum fields {
    paddingSize = "paddingSize",
    ipadPaddingSize = "ipadPaddingSize",
    mobilePaddingSize = "mobilePaddingSize",
    backgroundColor = "backgroundColor",
}

interface SpacerProps extends WidgetProps {
    fields: {
        [fields.paddingSize]: string;
        [fields.ipadPaddingSize]: string;
        [fields.mobilePaddingSize]: string;
        [fields.backgroundColor]: string;
    };
}

const spacerTemplateWidget: React.FC<SpacerProps> = props => {
    const paddingSize = Number(props.fields.paddingSize);
    const ipadPaddingSize = Number(props.fields.ipadPaddingSize);
    const mobilePaddingSize = Number(props.fields.mobilePaddingSize);

    const cssBlock = css`
        height: ${paddingSize}px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: ${props.fields.backgroundColor};

        ${xScreen("lte", "md")} {
            height: ${ipadPaddingSize}px;
        }
        ${xScreen("lte", "sm")} {
            height: ${mobilePaddingSize}px;
        }
    `;

    return <StyledWrapper css={cssBlock} />;
};

export const definition: WidgetDefinition = {
    group: "XNGAGE" as any,
    fieldDefinitions: [
        {
            name: fields.paddingSize,
            displayName: "Desktop Padding Size in Pixels",
            editorTemplate: "IntegerField",
            defaultValue: 50,
            fieldType: "General",
            min: 0,
        },
        {
            name: fields.ipadPaddingSize,
            displayName: "iPad Padding Size in Pixels",
            editorTemplate: "IntegerField",
            defaultValue: 30,
            fieldType: "General",
            min: 0,
        },
        {
            name: fields.mobilePaddingSize,
            displayName: "Mobile Padding Size",
            editorTemplate: "IntegerField",
            defaultValue: 20,
            fieldType: "General",
            min: 0,
        },
        {
            fieldType: "General",
            name: fields.backgroundColor,
            editorTemplate: "ColorPickerField",
            displayName: "Background Color",
            defaultValue: "white",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: spacerTemplateWidget,
    definition,
};

export default widgetModule;
